import { trpc } from '@klear/ui/lib/trpc'
import { useMutationWithToast, createToastConfig } from '@klear/ui/hooks/use-mutations-with-toast'

const invalidateQueries = ['klearAccount.list', 'klearAccount.getById', 'klearAccount.getTransactions']

export function useBankPaymentMutations() {
  const createBankPaymentMutation = useMutationWithToast(
    trpc.bankPayment.create.useMutation,
    createToastConfig('Bank Payment', 'create'),
    {
      invalidateQueries
    }
  )

  return {
    createBankPayment: createBankPaymentMutation.mutateAsync,
    isCreating: createBankPaymentMutation.isPending
  }
}
